import { useContext, useEffect, useState } from "react";

import { getMyConversation } from "../api/chatService";
import { ROLES, normalizeRole } from "../auth/access";
import {
   getChatToastContext,
} from "../stores/chatToastContext";
import {
   getChatUnread,
   markChatUnread,
   subscribeChatUnread,
   syncChatUnreadFromMessages,
} from "../stores/chatUnreadStore";
import { isStaffMessage } from "../utils/chatMessageFormat";
import { UserContext } from "../UserContext";
import useChatSocket from "./useChatSocket";

export default function useChatUnread() {
   const { user, loading } = useContext(UserContext);
   const isStudent = normalizeRole(user?.role) === ROLES.USER;
   const canAccess = Boolean(user?.id) && isStudent;

   const [hasUnread, setHasUnread] = useState(false);

   useEffect(() => {
      if (!canAccess) {
         setHasUnread(false);
         return undefined;
      }

      setHasUnread(getChatUnread());
      return subscribeChatUnread(() => setHasUnread(getChatUnread()));
   }, [canAccess]);

   useEffect(() => {
      if (!canAccess || loading) return undefined;

      let cancelled = false;

      (async () => {
         try {
            const conversation = await getMyConversation();
            if (cancelled) return;
            syncChatUnreadFromMessages(conversation?.messages, {
               isStaffMessage,
            });
         } catch {
            // silent
         }
      })();

      return () => {
         cancelled = true;
      };
   }, [canAccess, loading]);

   useChatSocket(canAccess && !loading, (message) => {
      if (!message?.id || !isStaffMessage(message)) return;

      const ctx = getChatToastContext();
      if (
         ctx.popupOpen &&
         ctx.conversationId != null &&
         Number(ctx.conversationId) === Number(message.conversationId)
      ) {
         return;
      }

      markChatUnread();
   });

   return { canAccess, hasUnread: canAccess && hasUnread };
}
